import { isMobile } from '../utils/device.js';

class Tutorial {
  constructor() {
    this.mobile = isMobile();
    this.steps   = this.mobile ? this._buildMobileSteps() : this._buildDesktopSteps();
    this.current = 0;
    this.els     = {};
    this.isActive = false;
    this.onClose  = null;
    this._litElements = []; // elementi temporaneamente riabilitati durante lo spotlight
  }

  // Diapositive desktop
  _buildDesktopSteps() {
    return [
      {
        target: null,
        title:  'Benvenut* in HomeCraft! 🏠',
        text:   'Ciao! Sono qui per guidarti nell\'uso dell\'app. Ti mostrerò tutti gli strumenti disponibili. Usa le frecce ← → per navigare tra le diapositive.'
      },
      {
        target: '.toolbar',
        title:  'Toolbar Principale',
        text:   'Da qui puoi <strong>salvare 💾</strong> (S), <strong>caricare 📂</strong> (C) e <strong>aggiornare 🔄</strong> (A) i tuoi progetti. Il lucchetto 🔒 (L) protegge la scena da modifiche accidentali.'
      },
      {
        target: '#btn-wall',
        title:  'Disegna Pareti 🧱',
        text:   'Attiva la <strong>modalità disegno pareti</strong> con questo bottone o con <kbd>W</kbd>. <strong>Clicca</strong> per piazzare il primo punto, poi <strong>clicca di nuovo</strong> per completare la parete. <kbd>ESC</kbd> per annullare.'
      },
      {
        target: '#btn-rotate',
        title:  'Ruota Oggetto 🔃',
        text:   'Seleziona uno o più oggetti e poi premi questo bottone o <kbd>R</kbd> per <strong>ruotarli</strong>. Seleziona più oggetti con <kbd>Ctrl+Click</kbd>.'
      },
      {
        target: '#btn-duplicate',
        title:  'Duplica Oggetto 📋',
        text:   'Seleziona uno o più oggetti e premi questo bottone o <kbd>D</kbd> per <strong>duplicarli</strong>. I duplicati vengono posizionati accanto all\'originale.'
      },
      {
        target: '#btn-delete',
        title:  'Elimina Oggetto ❌',
        text:   'Seleziona uno o più oggetti e premi questo bottone o <kbd>Canc</kbd> per <strong>eliminarli</strong> dalla scena.'
      },
      {
        target: '#btn-toggle-all',
        title:  'Apri/Chiudi Tutto ▶️',
        text:   'Questo bottone o <kbd>O</kbd> <strong>apre o chiude tutte le porte e finestre</strong> presenti nella scena in una volta sola.'
      },
      {
        target: '#btn-first-person',
        title:  'Vista in Prima Persona 🧍',
        text:   'Premi questo bottone o <kbd>P</kbd> per esplorare la scena <strong>in prima persona</strong>. Usa <kbd>W/S</kbd> o <kbd>↑/↓</kbd> per avanzare/indietreggiare, <kbd>A/D</kbd> o <kbd>←/→</kbd> per ruotare. <strong>Trascina il mouse</strong> per guardarti attorno. <kbd>ESC</kbd> per uscire.'
      },
      {
        target: '#catalog-panel',
        title:  'Catalogo Oggetti 📦',
        text:   'Espandi una categoria e <strong>trascina un oggetto</strong> nella scena per posizionarlo. Usa la <strong>barra di ricerca</strong> per filtrare gli oggetti. Puoi anche caricare i tuoi <strong>modelli 3D</strong> (GLB/GLTF).'
      },
      {
        target: null,
        title:  'Selezione e Spostamento',
        text:   '<strong>Clicca</strong> su un oggetto per selezionarlo (evidenziato in azzurro). <strong>Trascina</strong> per spostarlo. Usa <kbd>Ctrl+Click</kbd> per la <strong>selezione multipla</strong>. <kbd>ESC</kbd> per deselezionare tutto.'
      },
      {
        target: null,
        title:  'Porte e Finestre 🚪🪟',
        text:   'Posiziona porte e finestre su una parete con i bottoni 🚪 🪟 del pannello. Poi fai <strong>doppio click</strong> su una porta o finestra per <strong>aprirla o chiuderla</strong>.'
      },
      {
        target: null,
        title:  'Navigazione 3D',
        text:   '<strong>Click sinistro + trascina</strong> per ruotare la vista. <strong>Click destro + trascina</strong> per spostarla. <strong>Rotella del mouse</strong> per zoomare.'
      },
      {
        target: '#btn-tutorial',
        title:  'Tutto pronto! 🎉',
        text:   'Sei pronto per progettare! Premi il bottone 🎓 o <kbd>T</kbd> in qualsiasi momento per rivedere questo tutorial. <strong>Buona progettazione!</strong>'
      }
    ];
  }

  // Diapositive mobile
  _buildMobileSteps() {
    return [
      {
        target: null,
        title:  'Benvenut* in HomeCraft! 🏠',
        text:   'Ciao! Sono qui per guidarti nell\'uso dell\'app. Ti mostrerò tutti gli strumenti disponibili. Usa le frecce ← → per navigare tra le diapositive.'
      },
      {
        target: '.toolbar',
        title:  'Toolbar Principale',
        text:   'Da qui puoi <strong>salvare 💾</strong>, <strong>caricare 📂</strong> e <strong>aggiornare 🔄</strong> i tuoi progetti. Il lucchetto 🔒 protegge la scena da modifiche accidentali.'
      },
      {
        target: '#btn-wall',
        title:  'Disegna Pareti 🧱',
        text:   'Attiva la <strong>modalità disegno pareti</strong> con questo bottone. <strong>Tocca e trascina</strong> per piazzare il primo punto, poi <strong>rilascia</strong> per completare la parete.'
      },
      {
        target: '#btn-rotate',
        title:  'Ruota Oggetto 🔃',
        text:   'Seleziona un oggetto e poi <strong>tocca</strong> questo bottone per <strong>ruotarlo</strong>.'
      },
      {
        target: '#btn-duplicate',
        title:  'Duplica Oggetto 📋',
        text:   'Seleziona un oggetto e <strong>tocca</strong> questo bottone per <strong>duplicarlo</strong>. Il duplicato viene posizionato accanto all\'originale.'
      },
      {
        target: '#btn-delete',
        title:  'Elimina Oggetto ❌',
        text:   'Seleziona un oggetto e <strong>tocca</strong> questo bottone per <strong>eliminarlo</strong> dalla scena.'
      },
      {
        target: '#btn-toggle-all',
        title:  'Apri/Chiudi Tutto ▶️',
        text:   'Questo bottone <strong>apre o chiude tutte le porte e finestre</strong> presenti nella scena in una volta sola.'
      },
      {
        target: '#btn-first-person',
        title:  'Vista in Prima Persona 🧍',
        text:   'Tocca questo bottone per esplorare la scena <strong>in prima persona</strong>. Usa il <strong>joystick sinistro</strong> per muoverti e ruotare. <strong>Trascina la metà destra</strong> dello schermo per guardarti attorno. Tocca <strong>✕</strong> per uscire.'
      },
      {
        target: '#catalog-panel',
        title:  'Catalogo Oggetti 📦',
        text:   'Espandi una categoria, poi <strong>tieni premuto e trascina</strong> un oggetto nella scena per posizionarlo. Usa la <strong>barra di ricerca</strong> per filtrare. Puoi caricare anche i tuoi <strong>modelli 3D</strong> (GLB/GLTF).'
      },
      {
        target: null,
        title:  'Selezione e Spostamento',
        text:   '<strong>Tocca</strong> un oggetto per selezionarlo. <strong>Trascina</strong> per spostarlo.'
      },
      {
        target: null,
        title:  'Porte e Finestre 🚪🪟',
        text:   'Posiziona porte e finestre su una parete con i bottoni 🚪 🪟 del pannello. Poi fai <strong>doppio tap</strong> su una porta o finestra per <strong>aprirla o chiuderla</strong>.'
      },
      {
        target: null,
        title:  'Navigazione 3D',
        text:   'Usa <strong>un dito</strong> per ruotare la vista. <strong>Due dita</strong> per spostarla. <strong>Pizzica</strong> per zoomare.'
      },
      {
        target: '#btn-tutorial',
        title:  'Tutto pronto! 🎉',
        text:   'Sei pronto per progettare! Tocca il bottone 🎓 in qualsiasi momento per rivedere questo tutorial. <strong>Buona progettazione!</strong>'
      }
    ];
  }

  // API pubbliche
  start() {
    if (this.isActive) return;
    this.isActive = true;
    this.current  = 0;
    this._buildDOM();
    this._showStep(0);
  }

  next() {
    if (this.current < this.steps.length - 1) {
      this.current++;
      this._showStep(this.current);
    } else {
      this.close();
    }
  }

  prev() {
    if (this.current > 0) {
      this.current--;
      this._showStep(this.current);
    }
  }

  close() {
    if (!this.isActive) return;
    this.isActive = false;

    const { overlay } = this.els;
    overlay.classList.add('tutorial-overlay--out');

    setTimeout(() => {
      overlay.remove();
      this.els = {};
    }, 350);

    this._restoreDisabled();
    try { localStorage.setItem('homecraft-tutorial-seen', '1'); } catch (_) {}
    this.onClose?.();
  }

  static shouldAutoStart() {
    try { return !localStorage.getItem('homecraft-tutorial-seen'); } catch (_) { return true; }
  }

  // DOM
  _buildDOM() {
    // Root overlay
    const overlay = document.createElement('div');
    overlay.className = 'tutorial-overlay';

    // Spotlight
    const spotlight = document.createElement('div');
    spotlight.className = 'tutorial-spotlight';
    spotlight.style.display = 'none';

    // Bottone chiudi tutorial
    const btnClose = document.createElement('button');
    btnClose.className = 'tutorial-btn-close';
    btnClose.innerHTML = '&#10005;';
    btnClose.title = 'Chiudi tutorial';
    btnClose.addEventListener('click', () => this.close());

    // Pannello avatar + nuvoletta
    const panel = document.createElement('div');
    panel.className = 'tutorial-panel';

    // Avatar
    const avatar = document.createElement('img');
    avatar.className = 'tutorial-avatar';
    avatar.src = '/assets/thumbnails/Marco.png';
    avatar.alt = 'Assistente';
    // Fallback se l'immagine non esiste
    avatar.onerror = () => {
      avatar.style.display = 'none';
      panel.classList.add('tutorial-panel--no-avatar');
    };

    // Nuvoletta
    const bubble = document.createElement('div');
    bubble.className = 'tutorial-bubble';

    const bubbleTitle = document.createElement('div');
    bubbleTitle.className = 'tutorial-bubble-title';

    const bubbleText = document.createElement('div');
    bubbleText.className = 'tutorial-bubble-text';

    // Controlli dentro la nuvoletta
    const controls = document.createElement('div');
    controls.className = 'tutorial-controls';

    const btnPrev = document.createElement('button');
    btnPrev.className = 'tutorial-btn-nav';
    btnPrev.innerHTML = '&#8592;';
    btnPrev.title = 'Indietro';
    btnPrev.addEventListener('click', () => this.prev());

    const counter = document.createElement('span');
    counter.className = 'tutorial-counter';

    const btnNext = document.createElement('button');
    btnNext.className = 'tutorial-btn-nav';
    btnNext.innerHTML = '&#8594;';
    btnNext.title = 'Avanti';
    btnNext.addEventListener('click', () => this.next());

    controls.appendChild(btnPrev);
    controls.appendChild(counter);
    controls.appendChild(btnNext);

    // Assembla la nuvoletta: btnClose è dentro la bubble, in alto a destra (position: absolute)
    bubble.appendChild(btnClose);
    bubble.appendChild(bubbleTitle);
    bubble.appendChild(bubbleText);
    bubble.appendChild(controls);

    panel.appendChild(avatar);
    panel.appendChild(bubble);

    overlay.appendChild(spotlight);
    overlay.appendChild(panel);

    document.body.appendChild(overlay);

    this.els = { overlay, spotlight, panel, avatar, bubble, bubbleTitle, bubbleText, counter, btnPrev, btnNext };

    // Navigazione con tastiera
    this._onKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === 'Enter') { e.preventDefault(); this.next(); }
      if (e.key === 'ArrowLeft')                        { e.preventDefault(); this.prev(); }
      if (e.key === 'Escape')                           { e.preventDefault(); this.close(); }
    };
    document.addEventListener('keydown', this._onKeyDown);
  }

  // Rendering delle diapositive
  _showStep(index) {
    const step = this.steps[index];
    const { overlay, spotlight, bubbleTitle, bubbleText, counter, btnPrev, btnNext } = this.els;

    // Ripristina bottoni disabilitati dallo step precedente
    this._restoreDisabled();

    // Testi
    bubbleTitle.textContent = step.title;
    bubbleText.innerHTML    = step.text;
    counter.textContent     = `${index + 1} / ${this.steps.length}`;

    // Stato di navigazione
    btnPrev.disabled = index === 0;
    btnNext.innerHTML = index === this.steps.length - 1
      ? 'Fine ✓'
      : '&#8594;';

    // Spotlight
    if (step.target) {
      const el = document.querySelector(step.target);
      if (el) {
        const r   = el.getBoundingClientRect();
        const pad = 10;
        const br  = getComputedStyle(el).borderRadius || '8px';

        spotlight.style.display      = 'block';
        spotlight.style.top          = `${r.top    - pad}px`;
        spotlight.style.left         = `${r.left   - pad}px`;
        spotlight.style.width        = `${r.width  + pad * 2}px`;
        spotlight.style.height       = `${r.height + pad * 2}px`;
        spotlight.style.borderRadius = br;

        overlay.classList.remove('tutorial-overlay--dark');

        // Accende temporaneamente i bottoni disabilitati nell'area spotlight
        el.querySelectorAll(':disabled, [disabled]').forEach(btn => {
          this._litElements.push(btn);
          btn.style.transition = 'none';
          btn.disabled = false;
          btn.classList.add('tutorial-lit');
        });
        if (el.disabled) {
          this._litElements.push(el);
          el.style.transition = 'none';
          el.disabled = false;
          el.classList.add('tutorial-lit');
        }
      } else {
        spotlight.style.display = 'none';
        overlay.classList.add('tutorial-overlay--dark');
      }
    } else {
      spotlight.style.display = 'none';
      overlay.classList.add('tutorial-overlay--dark');
    }
  }

  // Ripristina tutti gli elementi temporaneamente riabilitati
  _restoreDisabled() {
    this._litElements.forEach(btn => {
      btn.disabled = true;
      btn.classList.remove('tutorial-lit');
      btn.style.transition = '';
    });
    this._litElements = [];
  }

  // Cleanup
  dispose() {
    if (this._onKeyDown) {
      document.removeEventListener('keydown', this._onKeyDown);
    }
  }
}

export default Tutorial;